import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconSadFace from 'components/icons/iconSadFace';
const CollectionsGridEmpty = t0 => {
  const $ = _c(6);
  const {
    clearFilters
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="inline-block align-top mr-[2.7rem]"><IconSadFace /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h4 className="text-xl font-bold text-gray mb-[9px]">Unfortunately, none of our collections match that criteria.</h4>;
    t3 = <div className="text-base font-bold text-gray">Please try a different combination of filters.</div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <i />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== clearFilters) {
    t5 = <div className="px-[3.333vw] py-8 relative">{t1}<div className="inline-block">{t2}{t3}<button className="rounded-[20px] bg-[rgba(216,98,98,.1)] text-red pt-[7px] pr-[21px] pb-[7px] pl-[35px] relative border-0 mt-3.5 cursor-pointer [&_i]:absolute [&_i]:left-5 [&_i]:top-1/2 [&_i:after]:[content:''] [&_i:after]:absolute [&_i:after]:w-[15px] [&_i:after]:h-px [&_i:after]:bg-red [&_i:after]:rounded-sm [&_i:after]:top-1/2 [&_i:after]:transition-[all_.3s] [&_i:before]:[content:''] [&_i:before]:absolute [&_i:before]:w-[15px] [&_i:before]:h-px [&_i:before]:bg-red [&_i:before]:rounded-sm [&_i:before]:top-1/2 [&_i:before]:transition-[all_.3s] [&_i:before]:rotate-45 [&_i:before]:left-1/2 [&_i:before]:ml-[-7.5px] [&_i:before]:-mt-px [&_i:before]:text-red [&_i:after]:-rotate-45 [&_i:after]:right-1/2 [&_i:after]:mr-[-7.5px] [&_i:after]:-mt-px [&_i:after]:text-red" onClick={clearFilters} type="button">{t4}Clear all</button></div></div>;
    $[4] = clearFilters;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
CollectionsGridEmpty.propTypes = {
  clearFilters: PropTypes.func.isRequired
};
export default CollectionsGridEmpty;